import { render, staticRenderFns } from "./orderitem.vue?vue&type=template&id=305efd76&scoped=true&"
import script from "./orderitem.vue?vue&type=script&lang=js&"
export * from "./orderitem.vue?vue&type=script&lang=js&"
import style0 from "./orderitem.vue?vue&type=style&index=0&id=305efd76&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305efd76",
  null
  
)

export default component.exports